/**
 * removes invalid characters from filename before upload.
 */
const scrubFilename = (filename) => filename.replace(/[^\w\d_\-\.]+/gi, "");
export default scrubFilename;
